import SimilarPropertiesModal from 'src/components/similar-properties-modal/SimilarPropertiesModal';

export default SimilarPropertiesModal;
export * from 'src/components/similar-properties-modal/find-similar-properties';
export * from 'src/components/similar-properties-modal/build-property-pitch';
